import React from "react";

export const Maintenance: React.FC<{}> = () => {
  return (
    <div className="maintenance">
      <div className="verticalCenterWrapper">
        <img src="/images/maintenance.jpg" alt="Maintenance PGN" />
      </div>
    </div>
  );
};
